import React from 'react';

/* Market-data health, pair x timeframe. Coloured BY STALENESS ONLY, with a
   hatched cell for a known gap — hatching distinguishes gap from late without
   inventing a sixth colour. */

const TONE = {
  fresh: 'var(--bg-inset)',
  ageing: 'color-mix(in oklab, var(--attn) 45%, var(--bg-inset))',
  stale: 'color-mix(in oklab, var(--loss) 55%, var(--bg-inset))',
};

export function StatusMatrixCell({ state = 'fresh', gap = false, title, size = 26, style }) {
  return (
    <div title={title} style={{
      width: size, height: size, background: TONE[state] || TONE.fresh,
      border: '1px solid var(--bg-canvas)',
      backgroundImage: gap ? 'repeating-linear-gradient(45deg, var(--border-strong) 0 2px, transparent 2px 5px)' : 'none',
      ...style,
    }} />
  );
}
